import { DisputeTypes } from "../../../shared/constants";
import { BackofficeDisputes } from "./disputes";

export function BackofficePaymentFacilitatorDisputes() {
  return (
    <BackofficeDisputes
      disputeType={DisputeTypes.Backoffice.PaymentFacilitatorDisputes}
    />
  );
}
